import darkThemeColors from './colors/darkThemeColors.mjs';
import theme from './theme.mjs';

var darkTheme = Object.assign(Object.assign({}, theme), { name: 'dark', colors: darkThemeColors, gradients: {
        imageOverlay: `linear-gradient(180deg, transparent 29.66%, ${darkThemeColors.slate} 89.13%)`,
        heroImageOverlay: `linear-gradient(180deg, transparent 27.3%, ${darkThemeColors.slate} 82.04%)`,
        heroImageUnderlay: `linear-gradient(180deg, ${darkThemeColors.slate}66 0%, ${darkThemeColors.slate} 89.13%)`,
        platformsOverlay: `linear-gradient(180deg, transparent 25.38%, ${darkThemeColors.slate}E8 71.45%, ${darkThemeColors.slate} 100%)`,
        videoOverlay: `linear-gradient(180deg, ${darkThemeColors.slate} 0%, ${darkThemeColors.slate} 105.89%)`,
        videoControlBarOverlay: `linear-gradient(180deg, ${darkThemeColors.slate}00 0%, ${darkThemeColors.slate}80 100%)`,
        horizontalCarousel: {
            prevButton: `linear-gradient( 270deg, ${darkThemeColors.slate}00 0%, ${darkThemeColors.slate}96 37.98%, ${darkThemeColors.slate} 100% )`,
            nextButton: `linear-gradient( 270deg, ${darkThemeColors.slate} 0%, ${darkThemeColors.slate}96 63.02%, ${darkThemeColors.slate}00 100% )`
        },
        horizontalList: {
            nextOverlay: `linear-gradient(270deg, ${darkThemeColors.slate} 0%, ${darkThemeColors.slate}00 100%)`,
            prevOverlay: `linear-gradient(90deg, ${darkThemeColors.slate} 0%, ${darkThemeColors.slate}00 100%)`
        },
        mediaCardSkeletonLoading: `linear-gradient(90deg, transparent 0%, ${darkThemeColors.slate}80 43%, ${darkThemeColors.slate}80 57%, transparent 100%)`
    }, shadows: {
        topNavigationTooltip: `0px 0px 20px 0px ${darkThemeColors.black}73`
    } });

export { darkTheme as default };
//# sourceMappingURL=darkTheme.mjs.map
